<div class="modal-backdrop" role="presentation" (click)="cancel.emit()">
  <section class="product-modal" role="dialog" aria-modal="true" aria-label="Product editor" (click)="$event.stopPropagation()">
    <header class="product-modal__header">
      <div>
        <p>{{ product ? 'Edit Product' : 'Add Product' }}</p>
        <h2>{{ product ? 'Edit Product' : 'Create Product' }}</h2>
      </div>
      <button type="button" class="close-button" aria-label="Close" (click)="cancel.emit()">×</button>
    </header>

    <form [formGroup]="productForm" (ngSubmit)="submit()">
      <div class="product-modal__body">
        <div class="product-form-grid">
          <label class="form-field">
            <span>Product Name</span>
            <input class="form-control" type="text" formControlName="productName" placeholder="Mushroom Compost" />
            <small *ngIf="showError('productName')">Product name is required.</small>
          </label>

          <label class="form-field">
            <span>Product Type</span>
            <select class="form-select" formControlName="productType">
              <option value="parent">Parent</option>
              <option value="child">Child</option>
            </select>
            <small *ngIf="showError('productType')">Product type is required.</small>
          </label>

          <label class="form-field" *ngIf="isChildProduct">
            <span>Parent Product</span>
            <select class="form-select" formControlName="parentId">
              <option value="">Select parent product</option>
              <option *ngFor="let parent of activeParentProducts" [value]="parent.id">{{ parent.name }}</option>
            </select>
            <small *ngIf="showError('parentId')">Parent product is required for child products.</small>
          </label>

          <label class="form-field">
            <span>Category</span>
            <input class="form-control" type="text" formControlName="category" placeholder="Compost" />
            <small *ngIf="showError('category')">Category is required.</small>
          </label>

          <label class="form-field">
            <span>Image URL</span>
            <input class="form-control" type="text" formControlName="imageUrl" placeholder="assets/sr-organic/mushroom-hero.png" />
          </label>

          <label class="form-field">
            <span>Display Order</span>
            <input class="form-control" type="number" formControlName="displayOrder" min="1" />
            <small *ngIf="showError('displayOrder')">Display order is required.</small>
          </label>

          <label class="form-field">
            <span>Status</span>
            <select class="form-select" formControlName="status">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
            <small *ngIf="showError('status')">Status is required.</small>
          </label>

          <label class="form-field">
            <span>Theme Color</span>
            <div class="color-field">
              <input class="color-control" type="color" formControlName="themeColor" aria-label="Product theme color" />
              <input class="form-control" type="text" formControlName="themeColor" placeholder="#c8ef5a" />
            </div>
            <small *ngIf="showError('themeColor')">Theme color is required.</small>
          </label>

          <label class="form-field toggle-field">
            <input type="checkbox" formControlName="featuredProduct" />
            <span>
              Featured Product
              <small>Reserved for future carousel controls.</small>
            </span>
          </label>

          <label class="form-field full-width">
            <span>Short Description</span>
            <textarea class="form-control" rows="3" formControlName="shortDescription"></textarea>
            <small *ngIf="showError('shortDescription')">Short description is required.</small>
          </label>

          <label class="form-field full-width">
            <span>Long Description</span>
            <textarea class="form-control" rows="4" formControlName="longDescription"></textarea>
          </label>
        </div>
      </div>

      <footer class="product-modal__footer">
        <button type="button" class="ghost-button" (click)="cancel.emit()">Cancel</button>
        <button type="submit">{{ product ? 'Update Product' : 'Save Product' }}</button>
      </footer>
    </form>
  </section>
</div>
